export const blockIconsTextformattingCloudDownloadNew = (
	<span className='material-symbols-outlined'>cloud_download</span>
);
